import { useNotificationToasts } from "./use-notification-toasts";

export function NotificationToastHost() {
  useNotificationToasts();
  return null;
}
